import 'angular-translate';

import { i18nEN } from './i18n.en.files';
import { i18nES } from './i18n.es.files';

export function localeConfig($translateProvider) {
    'ngInject';
    $translateProvider.translations('en', i18nEN);
    $translateProvider.translations('es', i18nES);
    // $translateProvider.useSanitizeValueStrategy(null);
}



// WEBPACK FOOTER //
// ./client/app/core/i18n/i18n.config.js